
















































































import { Vue, Component } from 'vue-property-decorator';
import omegaup_OverlayPopup from '../OverlayPopup.vue';
import T from '../../lang';
import * as ui from '../../ui';

export enum AvailableViews {
  Content,
  Question,
  Thanks,
}

@Component({
  components: {
    'omegaup-overlay-popup': omegaup_OverlayPopup,
  },
})
export default class QualityNominationDemotionPopup extends Vue {
  AvailableViews = AvailableViews;
  T = T;
  ui = ui;
  rationale = '';
  original = '';
  currentView = AvailableViews.Question;
  selectedReason = '';

  onHide(): void {
    this.$emit('dismiss');
  }

  onSubmit(): void {
    this.$emit('submit', this);
    this.currentView = AvailableViews.Thanks;
    setTimeout(() => this.onHide(), 2000);
  }
}
